/* eslint-disable sonarjs/no-duplicate-string */
import { useForm } from '@mantine/form';
import { TYPE_OF_TRANSACTION } from '@modules/opportunities/entities/opportunity/const';
import { ProposalCreationClientAndMortgageForm } from '@modules/proposals/presentation/v2/pages/ProposalCreation/views/ClientAndMortgage/types';
import { ltvAutoCalculator } from '.';

const buyoutOrEquity = (transactionType: string) => [
  TYPE_OF_TRANSACTION.buyout,
  TYPE_OF_TRANSACTION.buyoutEquity,
  TYPE_OF_TRANSACTION.equity
].includes(transactionType as 'buyout' | 'equity' | 'buyout_and_equity');

export const recalculateMortgageDetailsVaues = (
  form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
  field: string,
  isAlreadyHaveMortgage: boolean = false
// eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  if (isAlreadyHaveMortgage) {
    form.setFieldValue('mortgage_details.downpayment_amount', '0');
    form.setFieldValue('mortgage_details.down_payment', '0');
    return;
  }

  if (field === 'ltv' && Number(form.values.mortgage_details.ltv) > 100) {
    return;
  }
  if (field === 'downpayment' && Number(form.values.mortgage_details.down_payment) > 100) {
    return;
  }

  if (
    field === 'loan_value'
    && Number(form.values.mortgage_details.loan_value)
      > Number(form.values.mortgage_details.property_value)
  ) {
    return;
  }

  if (
    field === 'downpayment_amount'
    && Number(form.values.mortgage_details.downpayment_amount)
      > Number(form.values.mortgage_details.property_value)
  ) {
    return;
  }

  const {
    propertyValue,
    downPaymentPercent,
    downPaymentAmount,
    loanAmount,
    ltv,
  } = ltvAutoCalculator(field, {
    propertyValue: Number(form.values.mortgage_details.property_value),
    downPaymentPercent: Number(form.values.mortgage_details.down_payment),
    downPaymentAmount: Number(form.values.mortgage_details.downpayment_amount),
    loanAmount: Number(form.values.mortgage_details.loan_value),
    ltv: Number(form.values.mortgage_details.ltv),
  });

  form.setFieldValue('mortgage_details.property_value', propertyValue ? String(propertyValue) : '');
  form.setFieldValue('mortgage_details.loan_value', loanAmount ? String(loanAmount) : '');
  form.setFieldValue('mortgage_details.ltv', ltv ? String(ltv) : '');

  if (buyoutOrEquity(form.values.mortgage_details.transaction_type)) {
    form.setFieldValue('mortgage_details.downpayment_amount', '0');
    form.setFieldValue('mortgage_details.down_payment', '0');
  } else {
    form.setFieldValue('mortgage_details.downpayment_amount', downPaymentAmount ? String(downPaymentAmount) : '');
    form.setFieldValue('mortgage_details.down_payment', downPaymentPercent ? String(downPaymentPercent) : '');
  }
};
